import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { DialogSize } from '../confirmation-dialog/enumerations/dialog-size.enum';

const message = 'The user will be logged out for the privilege changes to take effect. Continue?';

export const userLogOutConfirmationPermissions = (confirmationDialogService: ConfirmationDialogService) => {
   const dialogRef = confirmationDialogService.confirm({
      data: {
         header: 'Update User Privileges',
         message,
      },
      size: DialogSize.Medium,
   });

   return dialogRef;
};

export const roleLogOutConfirmationPermissions = (confirmationDialogService: ConfirmationDialogService) => {
   const dialogRef = confirmationDialogService.confirm({
      data: {
         header: 'Update Role Privileges',
         message,
      },
      size: DialogSize.Medium,
   });

   return dialogRef;
};
